import { render, staticRenderFns } from "./UploadEvidence.vue?vue&type=template&id=7aa627e4&"
import script from "./UploadEvidence.vue?vue&type=script&lang=js&"
export * from "./UploadEvidence.vue?vue&type=script&lang=js&"
import style0 from "./UploadEvidence.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports